/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanBaseResponse } from '../models/boolean-base-response';
import { InspectionDto } from '../models/inspection-dto';
import { InspectionDtoBaseResponse } from '../models/inspection-dto-base-response';
import { InspectionDtoListBaseResponse } from '../models/inspection-dto-list-base-response';
import { InspectionFileDto } from '../models/inspection-file-dto';
import { InspectionFileDtoBaseResponse } from '../models/inspection-file-dto-base-response';
import { InspectionFileDtoListBaseResponse } from '../models/inspection-file-dto-list-base-response';
import { InspectionItemDto } from '../models/inspection-item-dto';
import { InspectionItemDtoBaseResponse } from '../models/inspection-item-dto-base-response';
import { InspectionListDtoPagedResponseBaseResponse } from '../models/inspection-list-dto-paged-response-base-response';
import { InspectionPackDto } from '../models/inspection-pack-dto';
import { InspectionPackDtoBaseResponse } from '../models/inspection-pack-dto-base-response';
import { InspectionPackDtoListBaseResponse } from '../models/inspection-pack-dto-list-base-response';
import { InspectionPackListDtoPagedResponseBaseResponse } from '../models/inspection-pack-list-dto-paged-response-base-response';
import { MeasuringEquipmentDto } from '../models/measuring-equipment-dto';
import { MeasuringEquipmentDtoBaseResponse } from '../models/measuring-equipment-dto-base-response';
import { MeasuringEquipmentDtoListBaseResponse } from '../models/measuring-equipment-dto-list-base-response';
import { MeasuringEquipmentDtoPagedResponseBaseResponse } from '../models/measuring-equipment-dto-paged-response-base-response';
import { OrderDirection } from '../models/order-direction';
import { PropertyFilter } from '../models/property-filter';

@Injectable({
  providedIn: 'root',
})
export class InspectionService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiInspectionPaginatedListGet
   */
  static readonly ApiInspectionPaginatedListGetPath = '/api/Inspection/paginated-list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionPaginatedListGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionPaginatedListGet$Plain$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<InspectionListDtoPagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionPaginatedListGetPath, 'get');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionListDtoPagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionPaginatedListGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionPaginatedListGet$Plain(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<InspectionListDtoPagedResponseBaseResponse> {

    return this.apiInspectionPaginatedListGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionListDtoPagedResponseBaseResponse>) => r.body as InspectionListDtoPagedResponseBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionPaginatedListGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionPaginatedListGet$Json$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<InspectionListDtoPagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionPaginatedListGetPath, 'get');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionListDtoPagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionPaginatedListGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionPaginatedListGet$Json(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<InspectionListDtoPagedResponseBaseResponse> {

    return this.apiInspectionPaginatedListGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionListDtoPagedResponseBaseResponse>) => r.body as InspectionListDtoPagedResponseBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionSearchAllGet
   */
  static readonly ApiInspectionSearchAllGetPath = '/api/Inspection/search-all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionSearchAllGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionSearchAllGet$Plain$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StrictHttpResponse<InspectionDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionSearchAllGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionSearchAllGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionSearchAllGet$Plain(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<InspectionDtoListBaseResponse> {

    return this.apiInspectionSearchAllGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionDtoListBaseResponse>) => r.body as InspectionDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionSearchAllGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionSearchAllGet$Json$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StrictHttpResponse<InspectionDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionSearchAllGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionSearchAllGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionSearchAllGet$Json(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<InspectionDtoListBaseResponse> {

    return this.apiInspectionSearchAllGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionDtoListBaseResponse>) => r.body as InspectionDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionGetInspectionGet
   */
  static readonly ApiInspectionGetInspectionGetPath = '/api/Inspection/get-inspection';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionGetInspectionGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionGetInspectionGet$Plain$Response(params?: {
    inspectionId?: number;
  }): Observable<StrictHttpResponse<InspectionDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionGetInspectionGetPath, 'get');
    if (params) {
      rb.query('inspectionId', params.inspectionId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionGetInspectionGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionGetInspectionGet$Plain(params?: {
    inspectionId?: number;
  }): Observable<InspectionDtoBaseResponse> {

    return this.apiInspectionGetInspectionGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionDtoBaseResponse>) => r.body as InspectionDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionGetInspectionGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionGetInspectionGet$Json$Response(params?: {
    inspectionId?: number;
  }): Observable<StrictHttpResponse<InspectionDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionGetInspectionGetPath, 'get');
    if (params) {
      rb.query('inspectionId', params.inspectionId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionGetInspectionGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionGetInspectionGet$Json(params?: {
    inspectionId?: number;
  }): Observable<InspectionDtoBaseResponse> {

    return this.apiInspectionGetInspectionGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionDtoBaseResponse>) => r.body as InspectionDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionAddInspectionPost
   */
  static readonly ApiInspectionAddInspectionPostPath = '/api/Inspection/add-inspection';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionAddInspectionPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionAddInspectionPost$Plain$Response(params?: {
    body?: InspectionDto
  }): Observable<StrictHttpResponse<InspectionDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionAddInspectionPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionAddInspectionPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionAddInspectionPost$Plain(params?: {
    body?: InspectionDto
  }): Observable<InspectionDtoBaseResponse> {

    return this.apiInspectionAddInspectionPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionDtoBaseResponse>) => r.body as InspectionDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionAddInspectionPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionAddInspectionPost$Json$Response(params?: {
    body?: InspectionDto
  }): Observable<StrictHttpResponse<InspectionDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionAddInspectionPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionAddInspectionPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionAddInspectionPost$Json(params?: {
    body?: InspectionDto
  }): Observable<InspectionDtoBaseResponse> {

    return this.apiInspectionAddInspectionPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionDtoBaseResponse>) => r.body as InspectionDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionUpdateInspectionPut
   */
  static readonly ApiInspectionUpdateInspectionPutPath = '/api/Inspection/update-inspection';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionUpdateInspectionPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionUpdateInspectionPut$Plain$Response(params?: {
    body?: InspectionDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionUpdateInspectionPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionUpdateInspectionPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionUpdateInspectionPut$Plain(params?: {
    body?: InspectionDto
  }): Observable<BooleanBaseResponse> {

    return this.apiInspectionUpdateInspectionPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionUpdateInspectionPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionUpdateInspectionPut$Json$Response(params?: {
    body?: InspectionDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionUpdateInspectionPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionUpdateInspectionPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionUpdateInspectionPut$Json(params?: {
    body?: InspectionDto
  }): Observable<BooleanBaseResponse> {

    return this.apiInspectionUpdateInspectionPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionToggleArchiveInspectionPut
   */
  static readonly ApiInspectionToggleArchiveInspectionPutPath = '/api/Inspection/toggle-archive-inspection';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionToggleArchiveInspectionPut$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionToggleArchiveInspectionPut$Plain$Response(params?: {
    inspectionId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionToggleArchiveInspectionPutPath, 'put');
    if (params) {
      rb.query('inspectionId', params.inspectionId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionToggleArchiveInspectionPut$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionToggleArchiveInspectionPut$Plain(params?: {
    inspectionId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiInspectionToggleArchiveInspectionPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionToggleArchiveInspectionPut$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionToggleArchiveInspectionPut$Json$Response(params?: {
    inspectionId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionToggleArchiveInspectionPutPath, 'put');
    if (params) {
      rb.query('inspectionId', params.inspectionId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionToggleArchiveInspectionPut$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionToggleArchiveInspectionPut$Json(params?: {
    inspectionId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiInspectionToggleArchiveInspectionPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionAddInspectionItemPost
   */
  static readonly ApiInspectionAddInspectionItemPostPath = '/api/Inspection/add-inspection-item';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionAddInspectionItemPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionAddInspectionItemPost$Plain$Response(params?: {
    body?: InspectionItemDto
  }): Observable<StrictHttpResponse<InspectionItemDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionAddInspectionItemPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionItemDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionAddInspectionItemPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionAddInspectionItemPost$Plain(params?: {
    body?: InspectionItemDto
  }): Observable<InspectionItemDtoBaseResponse> {

    return this.apiInspectionAddInspectionItemPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionItemDtoBaseResponse>) => r.body as InspectionItemDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionAddInspectionItemPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionAddInspectionItemPost$Json$Response(params?: {
    body?: InspectionItemDto
  }): Observable<StrictHttpResponse<InspectionItemDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionAddInspectionItemPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionItemDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionAddInspectionItemPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionAddInspectionItemPost$Json(params?: {
    body?: InspectionItemDto
  }): Observable<InspectionItemDtoBaseResponse> {

    return this.apiInspectionAddInspectionItemPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionItemDtoBaseResponse>) => r.body as InspectionItemDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionUpdateInspectionItemPut
   */
  static readonly ApiInspectionUpdateInspectionItemPutPath = '/api/Inspection/update-inspection-item';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionUpdateInspectionItemPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionUpdateInspectionItemPut$Plain$Response(params?: {
    body?: InspectionItemDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionUpdateInspectionItemPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionUpdateInspectionItemPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionUpdateInspectionItemPut$Plain(params?: {
    body?: InspectionItemDto
  }): Observable<BooleanBaseResponse> {

    return this.apiInspectionUpdateInspectionItemPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionUpdateInspectionItemPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionUpdateInspectionItemPut$Json$Response(params?: {
    body?: InspectionItemDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionUpdateInspectionItemPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionUpdateInspectionItemPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionUpdateInspectionItemPut$Json(params?: {
    body?: InspectionItemDto
  }): Observable<BooleanBaseResponse> {

    return this.apiInspectionUpdateInspectionItemPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionArchiveInspectionItemPut
   */
  static readonly ApiInspectionArchiveInspectionItemPutPath = '/api/Inspection/archive-inspection-item';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionArchiveInspectionItemPut$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionArchiveInspectionItemPut$Plain$Response(params?: {
    inspectionItemId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionArchiveInspectionItemPutPath, 'put');
    if (params) {
      rb.query('inspectionItemId', params.inspectionItemId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionArchiveInspectionItemPut$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionArchiveInspectionItemPut$Plain(params?: {
    inspectionItemId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiInspectionArchiveInspectionItemPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionArchiveInspectionItemPut$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionArchiveInspectionItemPut$Json$Response(params?: {
    inspectionItemId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionArchiveInspectionItemPutPath, 'put');
    if (params) {
      rb.query('inspectionItemId', params.inspectionItemId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionArchiveInspectionItemPut$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionArchiveInspectionItemPut$Json(params?: {
    inspectionItemId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiInspectionArchiveInspectionItemPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionPaginatedMeasuringEquipmentGet
   */
  static readonly ApiInspectionPaginatedMeasuringEquipmentGetPath = '/api/Inspection/paginated-measuring-equipment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionPaginatedMeasuringEquipmentGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionPaginatedMeasuringEquipmentGet$Plain$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<MeasuringEquipmentDtoPagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionPaginatedMeasuringEquipmentGetPath, 'get');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MeasuringEquipmentDtoPagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionPaginatedMeasuringEquipmentGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionPaginatedMeasuringEquipmentGet$Plain(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<MeasuringEquipmentDtoPagedResponseBaseResponse> {

    return this.apiInspectionPaginatedMeasuringEquipmentGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<MeasuringEquipmentDtoPagedResponseBaseResponse>) => r.body as MeasuringEquipmentDtoPagedResponseBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionPaginatedMeasuringEquipmentGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionPaginatedMeasuringEquipmentGet$Json$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<MeasuringEquipmentDtoPagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionPaginatedMeasuringEquipmentGetPath, 'get');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MeasuringEquipmentDtoPagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionPaginatedMeasuringEquipmentGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionPaginatedMeasuringEquipmentGet$Json(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<MeasuringEquipmentDtoPagedResponseBaseResponse> {

    return this.apiInspectionPaginatedMeasuringEquipmentGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<MeasuringEquipmentDtoPagedResponseBaseResponse>) => r.body as MeasuringEquipmentDtoPagedResponseBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionGetAllMeasuringEquipmentGet
   */
  static readonly ApiInspectionGetAllMeasuringEquipmentGetPath = '/api/Inspection/get-all-measuring-equipment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionGetAllMeasuringEquipmentGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionGetAllMeasuringEquipmentGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<MeasuringEquipmentDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionGetAllMeasuringEquipmentGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MeasuringEquipmentDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionGetAllMeasuringEquipmentGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionGetAllMeasuringEquipmentGet$Plain(params?: {
  }): Observable<MeasuringEquipmentDtoListBaseResponse> {

    return this.apiInspectionGetAllMeasuringEquipmentGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<MeasuringEquipmentDtoListBaseResponse>) => r.body as MeasuringEquipmentDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionGetAllMeasuringEquipmentGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionGetAllMeasuringEquipmentGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<MeasuringEquipmentDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionGetAllMeasuringEquipmentGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MeasuringEquipmentDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionGetAllMeasuringEquipmentGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionGetAllMeasuringEquipmentGet$Json(params?: {
  }): Observable<MeasuringEquipmentDtoListBaseResponse> {

    return this.apiInspectionGetAllMeasuringEquipmentGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<MeasuringEquipmentDtoListBaseResponse>) => r.body as MeasuringEquipmentDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionSearchAllMeasuringEquipmentGet
   */
  static readonly ApiInspectionSearchAllMeasuringEquipmentGetPath = '/api/Inspection/search-all-measuring-equipment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionSearchAllMeasuringEquipmentGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionSearchAllMeasuringEquipmentGet$Plain$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StrictHttpResponse<MeasuringEquipmentDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionSearchAllMeasuringEquipmentGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MeasuringEquipmentDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionSearchAllMeasuringEquipmentGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionSearchAllMeasuringEquipmentGet$Plain(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<MeasuringEquipmentDtoListBaseResponse> {

    return this.apiInspectionSearchAllMeasuringEquipmentGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<MeasuringEquipmentDtoListBaseResponse>) => r.body as MeasuringEquipmentDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionSearchAllMeasuringEquipmentGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionSearchAllMeasuringEquipmentGet$Json$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StrictHttpResponse<MeasuringEquipmentDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionSearchAllMeasuringEquipmentGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MeasuringEquipmentDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionSearchAllMeasuringEquipmentGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionSearchAllMeasuringEquipmentGet$Json(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<MeasuringEquipmentDtoListBaseResponse> {

    return this.apiInspectionSearchAllMeasuringEquipmentGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<MeasuringEquipmentDtoListBaseResponse>) => r.body as MeasuringEquipmentDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionAddMeasuringEquipmentPost
   */
  static readonly ApiInspectionAddMeasuringEquipmentPostPath = '/api/Inspection/add-measuring-equipment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionAddMeasuringEquipmentPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionAddMeasuringEquipmentPost$Plain$Response(params?: {
    body?: MeasuringEquipmentDto
  }): Observable<StrictHttpResponse<MeasuringEquipmentDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionAddMeasuringEquipmentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MeasuringEquipmentDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionAddMeasuringEquipmentPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionAddMeasuringEquipmentPost$Plain(params?: {
    body?: MeasuringEquipmentDto
  }): Observable<MeasuringEquipmentDtoBaseResponse> {

    return this.apiInspectionAddMeasuringEquipmentPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<MeasuringEquipmentDtoBaseResponse>) => r.body as MeasuringEquipmentDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionAddMeasuringEquipmentPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionAddMeasuringEquipmentPost$Json$Response(params?: {
    body?: MeasuringEquipmentDto
  }): Observable<StrictHttpResponse<MeasuringEquipmentDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionAddMeasuringEquipmentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MeasuringEquipmentDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionAddMeasuringEquipmentPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionAddMeasuringEquipmentPost$Json(params?: {
    body?: MeasuringEquipmentDto
  }): Observable<MeasuringEquipmentDtoBaseResponse> {

    return this.apiInspectionAddMeasuringEquipmentPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<MeasuringEquipmentDtoBaseResponse>) => r.body as MeasuringEquipmentDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionUpdateMeasuringEquipmentPut
   */
  static readonly ApiInspectionUpdateMeasuringEquipmentPutPath = '/api/Inspection/update-measuring-equipment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionUpdateMeasuringEquipmentPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionUpdateMeasuringEquipmentPut$Plain$Response(params?: {
    body?: MeasuringEquipmentDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionUpdateMeasuringEquipmentPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionUpdateMeasuringEquipmentPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionUpdateMeasuringEquipmentPut$Plain(params?: {
    body?: MeasuringEquipmentDto
  }): Observable<BooleanBaseResponse> {

    return this.apiInspectionUpdateMeasuringEquipmentPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionUpdateMeasuringEquipmentPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionUpdateMeasuringEquipmentPut$Json$Response(params?: {
    body?: MeasuringEquipmentDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionUpdateMeasuringEquipmentPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionUpdateMeasuringEquipmentPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionUpdateMeasuringEquipmentPut$Json(params?: {
    body?: MeasuringEquipmentDto
  }): Observable<BooleanBaseResponse> {

    return this.apiInspectionUpdateMeasuringEquipmentPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionToggleArchiveMeasuringEquipmentPut
   */
  static readonly ApiInspectionToggleArchiveMeasuringEquipmentPutPath = '/api/Inspection/toggle-archive-measuring-equipment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionToggleArchiveMeasuringEquipmentPut$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionToggleArchiveMeasuringEquipmentPut$Plain$Response(params?: {
    measuringEquipmentId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionToggleArchiveMeasuringEquipmentPutPath, 'put');
    if (params) {
      rb.query('measuringEquipmentId', params.measuringEquipmentId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionToggleArchiveMeasuringEquipmentPut$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionToggleArchiveMeasuringEquipmentPut$Plain(params?: {
    measuringEquipmentId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiInspectionToggleArchiveMeasuringEquipmentPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionToggleArchiveMeasuringEquipmentPut$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionToggleArchiveMeasuringEquipmentPut$Json$Response(params?: {
    measuringEquipmentId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionToggleArchiveMeasuringEquipmentPutPath, 'put');
    if (params) {
      rb.query('measuringEquipmentId', params.measuringEquipmentId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionToggleArchiveMeasuringEquipmentPut$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionToggleArchiveMeasuringEquipmentPut$Json(params?: {
    measuringEquipmentId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiInspectionToggleArchiveMeasuringEquipmentPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionPaginatedListPacksGet
   */
  static readonly ApiInspectionPaginatedListPacksGetPath = '/api/Inspection/paginated-list-packs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionPaginatedListPacksGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionPaginatedListPacksGet$Plain$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<InspectionPackListDtoPagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionPaginatedListPacksGetPath, 'get');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionPackListDtoPagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionPaginatedListPacksGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionPaginatedListPacksGet$Plain(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<InspectionPackListDtoPagedResponseBaseResponse> {

    return this.apiInspectionPaginatedListPacksGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionPackListDtoPagedResponseBaseResponse>) => r.body as InspectionPackListDtoPagedResponseBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionPaginatedListPacksGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionPaginatedListPacksGet$Json$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<InspectionPackListDtoPagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionPaginatedListPacksGetPath, 'get');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionPackListDtoPagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionPaginatedListPacksGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionPaginatedListPacksGet$Json(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<InspectionPackListDtoPagedResponseBaseResponse> {

    return this.apiInspectionPaginatedListPacksGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionPackListDtoPagedResponseBaseResponse>) => r.body as InspectionPackListDtoPagedResponseBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionSearchAllPacksGet
   */
  static readonly ApiInspectionSearchAllPacksGetPath = '/api/Inspection/search-all-packs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionSearchAllPacksGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionSearchAllPacksGet$Plain$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StrictHttpResponse<InspectionPackDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionSearchAllPacksGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionPackDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionSearchAllPacksGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionSearchAllPacksGet$Plain(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<InspectionPackDtoListBaseResponse> {

    return this.apiInspectionSearchAllPacksGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionPackDtoListBaseResponse>) => r.body as InspectionPackDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionSearchAllPacksGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionSearchAllPacksGet$Json$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StrictHttpResponse<InspectionPackDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionSearchAllPacksGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionPackDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionSearchAllPacksGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionSearchAllPacksGet$Json(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<InspectionPackDtoListBaseResponse> {

    return this.apiInspectionSearchAllPacksGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionPackDtoListBaseResponse>) => r.body as InspectionPackDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionGetInspectionPackGet
   */
  static readonly ApiInspectionGetInspectionPackGetPath = '/api/Inspection/get-inspection-pack';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionGetInspectionPackGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionGetInspectionPackGet$Plain$Response(params?: {
    inspectionPackId?: number;
  }): Observable<StrictHttpResponse<InspectionPackDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionGetInspectionPackGetPath, 'get');
    if (params) {
      rb.query('inspectionPackId', params.inspectionPackId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionPackDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionGetInspectionPackGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionGetInspectionPackGet$Plain(params?: {
    inspectionPackId?: number;
  }): Observable<InspectionPackDtoBaseResponse> {

    return this.apiInspectionGetInspectionPackGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionPackDtoBaseResponse>) => r.body as InspectionPackDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionGetInspectionPackGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionGetInspectionPackGet$Json$Response(params?: {
    inspectionPackId?: number;
  }): Observable<StrictHttpResponse<InspectionPackDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionGetInspectionPackGetPath, 'get');
    if (params) {
      rb.query('inspectionPackId', params.inspectionPackId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionPackDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionGetInspectionPackGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionGetInspectionPackGet$Json(params?: {
    inspectionPackId?: number;
  }): Observable<InspectionPackDtoBaseResponse> {

    return this.apiInspectionGetInspectionPackGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionPackDtoBaseResponse>) => r.body as InspectionPackDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionAddInspectionPackPost
   */
  static readonly ApiInspectionAddInspectionPackPostPath = '/api/Inspection/add-inspection-pack';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionAddInspectionPackPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionAddInspectionPackPost$Plain$Response(params?: {
    body?: InspectionPackDto
  }): Observable<StrictHttpResponse<InspectionPackDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionAddInspectionPackPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionPackDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionAddInspectionPackPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionAddInspectionPackPost$Plain(params?: {
    body?: InspectionPackDto
  }): Observable<InspectionPackDtoBaseResponse> {

    return this.apiInspectionAddInspectionPackPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionPackDtoBaseResponse>) => r.body as InspectionPackDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionAddInspectionPackPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionAddInspectionPackPost$Json$Response(params?: {
    body?: InspectionPackDto
  }): Observable<StrictHttpResponse<InspectionPackDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionAddInspectionPackPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionPackDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionAddInspectionPackPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionAddInspectionPackPost$Json(params?: {
    body?: InspectionPackDto
  }): Observable<InspectionPackDtoBaseResponse> {

    return this.apiInspectionAddInspectionPackPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionPackDtoBaseResponse>) => r.body as InspectionPackDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionUpdateInspectionPackPut
   */
  static readonly ApiInspectionUpdateInspectionPackPutPath = '/api/Inspection/update-inspection-pack';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionUpdateInspectionPackPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionUpdateInspectionPackPut$Plain$Response(params?: {
    body?: InspectionPackDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionUpdateInspectionPackPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionUpdateInspectionPackPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionUpdateInspectionPackPut$Plain(params?: {
    body?: InspectionPackDto
  }): Observable<BooleanBaseResponse> {

    return this.apiInspectionUpdateInspectionPackPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionUpdateInspectionPackPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionUpdateInspectionPackPut$Json$Response(params?: {
    body?: InspectionPackDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionUpdateInspectionPackPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionUpdateInspectionPackPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionUpdateInspectionPackPut$Json(params?: {
    body?: InspectionPackDto
  }): Observable<BooleanBaseResponse> {

    return this.apiInspectionUpdateInspectionPackPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionToggleArchiveInspectionPackPut
   */
  static readonly ApiInspectionToggleArchiveInspectionPackPutPath = '/api/Inspection/toggle-archive-inspection-pack';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionToggleArchiveInspectionPackPut$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionToggleArchiveInspectionPackPut$Plain$Response(params?: {
    inspectionPackId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionToggleArchiveInspectionPackPutPath, 'put');
    if (params) {
      rb.query('inspectionPackId', params.inspectionPackId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionToggleArchiveInspectionPackPut$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionToggleArchiveInspectionPackPut$Plain(params?: {
    inspectionPackId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiInspectionToggleArchiveInspectionPackPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionToggleArchiveInspectionPackPut$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionToggleArchiveInspectionPackPut$Json$Response(params?: {
    inspectionPackId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionToggleArchiveInspectionPackPutPath, 'put');
    if (params) {
      rb.query('inspectionPackId', params.inspectionPackId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionToggleArchiveInspectionPackPut$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionToggleArchiveInspectionPackPut$Json(params?: {
    inspectionPackId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiInspectionToggleArchiveInspectionPackPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionGetFilesGet
   */
  static readonly ApiInspectionGetFilesGetPath = '/api/Inspection/get-files';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionGetFilesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionGetFilesGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<InspectionFileDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionGetFilesGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionFileDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionGetFilesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionGetFilesGet$Plain(params?: {
  }): Observable<InspectionFileDtoListBaseResponse> {

    return this.apiInspectionGetFilesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionFileDtoListBaseResponse>) => r.body as InspectionFileDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionGetFilesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionGetFilesGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<InspectionFileDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionGetFilesGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionFileDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionGetFilesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionGetFilesGet$Json(params?: {
  }): Observable<InspectionFileDtoListBaseResponse> {

    return this.apiInspectionGetFilesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionFileDtoListBaseResponse>) => r.body as InspectionFileDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionUploadFileInspectionIdPost
   */
  static readonly ApiInspectionUploadFileInspectionIdPostPath = '/api/Inspection/upload-file/{inspectionId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionUploadFileInspectionIdPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiInspectionUploadFileInspectionIdPost$Plain$Response(params: {
    inspectionId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<InspectionFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionUploadFileInspectionIdPostPath, 'post');
    if (params) {
      rb.path('inspectionId', params.inspectionId, {});
      rb.query('filename', params.filename, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionUploadFileInspectionIdPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiInspectionUploadFileInspectionIdPost$Plain(params: {
    inspectionId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<InspectionFileDtoBaseResponse> {

    return this.apiInspectionUploadFileInspectionIdPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionFileDtoBaseResponse>) => r.body as InspectionFileDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionUploadFileInspectionIdPost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiInspectionUploadFileInspectionIdPost$Json$Response(params: {
    inspectionId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<InspectionFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionUploadFileInspectionIdPostPath, 'post');
    if (params) {
      rb.path('inspectionId', params.inspectionId, {});
      rb.query('filename', params.filename, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionUploadFileInspectionIdPost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiInspectionUploadFileInspectionIdPost$Json(params: {
    inspectionId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<InspectionFileDtoBaseResponse> {

    return this.apiInspectionUploadFileInspectionIdPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionFileDtoBaseResponse>) => r.body as InspectionFileDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionUpdateFilePost
   */
  static readonly ApiInspectionUpdateFilePostPath = '/api/Inspection/update-file';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionUpdateFilePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionUpdateFilePost$Plain$Response(params?: {
    body?: InspectionFileDto
  }): Observable<StrictHttpResponse<InspectionFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionUpdateFilePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionUpdateFilePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionUpdateFilePost$Plain(params?: {
    body?: InspectionFileDto
  }): Observable<InspectionFileDtoBaseResponse> {

    return this.apiInspectionUpdateFilePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionFileDtoBaseResponse>) => r.body as InspectionFileDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionUpdateFilePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionUpdateFilePost$Json$Response(params?: {
    body?: InspectionFileDto
  }): Observable<StrictHttpResponse<InspectionFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionUpdateFilePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionUpdateFilePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInspectionUpdateFilePost$Json(params?: {
    body?: InspectionFileDto
  }): Observable<InspectionFileDtoBaseResponse> {

    return this.apiInspectionUpdateFilePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionFileDtoBaseResponse>) => r.body as InspectionFileDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiInspectionDownloadFileFileIdGet
   */
  static readonly ApiInspectionDownloadFileFileIdGetPath = '/api/Inspection/download-file/{fileId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionDownloadFileFileIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionDownloadFileFileIdGet$Response(params: {
    fileId: number;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionDownloadFileFileIdGetPath, 'get');
    if (params) {
      rb.path('fileId', params.fileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionDownloadFileFileIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionDownloadFileFileIdGet(params: {
    fileId: number;
  }): Observable<string> {

    return this.apiInspectionDownloadFileFileIdGet$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation apiInspectionDeleteFileFileIdDelete
   */
  static readonly ApiInspectionDeleteFileFileIdDeletePath = '/api/Inspection/delete-file/{fileId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionDeleteFileFileIdDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionDeleteFileFileIdDelete$Plain$Response(params: {
    fileId: number;
  }): Observable<StrictHttpResponse<InspectionFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionDeleteFileFileIdDeletePath, 'delete');
    if (params) {
      rb.path('fileId', params.fileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionDeleteFileFileIdDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionDeleteFileFileIdDelete$Plain(params: {
    fileId: number;
  }): Observable<InspectionFileDtoBaseResponse> {

    return this.apiInspectionDeleteFileFileIdDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionFileDtoBaseResponse>) => r.body as InspectionFileDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInspectionDeleteFileFileIdDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionDeleteFileFileIdDelete$Json$Response(params: {
    fileId: number;
  }): Observable<StrictHttpResponse<InspectionFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InspectionService.ApiInspectionDeleteFileFileIdDeletePath, 'delete');
    if (params) {
      rb.path('fileId', params.fileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InspectionFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInspectionDeleteFileFileIdDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInspectionDeleteFileFileIdDelete$Json(params: {
    fileId: number;
  }): Observable<InspectionFileDtoBaseResponse> {

    return this.apiInspectionDeleteFileFileIdDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<InspectionFileDtoBaseResponse>) => r.body as InspectionFileDtoBaseResponse)
    );
  }

}
